const faqAccordion = document.querySelector('.faq-sec__container');

if (faqAccordion) {
  const faqItemsArr = document.querySelectorAll('.faq-sec__item');

  if (faqItemsArr.length) {
    const debounce = (func, wait) => {
      let timeout;
      return function executedFunction(...args) {
        const later = () => {
          clearTimeout(timeout);
          func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
      };
    };

    const setContentHeight = (item) => {
      const contentEl = item.querySelector('.faq-sec__item-content');
      if (!contentEl) return;

      if (item.classList.contains('is-active')) {
        contentEl.style.maxHeight = '';
        const contentHeight = contentEl.scrollHeight + 40;
        contentEl.style.maxHeight = `${contentHeight}px`;
      } else {
        contentEl.style.maxHeight = '';
      }
    };

    const openItem = (item) => {
      if (item.classList.contains('is-active')) return;

      faqItemsArr.forEach((otherItem) => {
        if (otherItem !== item && otherItem.classList.contains('is-active')) {
          closeItem(otherItem);
        }
      });

      item.classList.add('is-active');
      setContentHeight(item);

      if (item.previousElementSibling) {
        item.previousElementSibling.classList.remove('is-next-hovered');
      }
    };

    const closeItem = (item) => {
      item.classList.remove('is-active');
      setContentHeight(item);

      if (item.previousElementSibling) {
        item.previousElementSibling.classList.remove('is-next-hovered');
      }
    };

    faqItemsArr.forEach((item) => {
      const toggleEl = item.querySelector('.faq-sec__item-toggle');
      const btnEl = item.querySelector('.faq-sec__item-btn');

      if (item.classList.contains('is-active')) {
        setContentHeight(item);
      }

      item.addEventListener('click', () => {
        if (!item.classList.contains('is-active')) {
          openItem(item);
        }

        if (item.nextElementSibling) {
          item.nextElementSibling.classList.add('is-next-hovered');
        }
      });

      const closeElement = btnEl || toggleEl;
      if (closeElement) {
        closeElement.addEventListener('click', (e) => {
          if (item.classList.contains('is-active')) {
            e.stopPropagation();
            closeItem(item);
          }

          if (item.nextElementSibling) {
            item.nextElementSibling.classList.remove('is-next-hovered');
          }
        });
      }
    });

    const handleResize = debounce(() => {
      faqItemsArr.forEach((item) => {
        if (item.classList.contains('is-active')) {
          setContentHeight(item);
        }
      });
    }, 300);

    window.addEventListener('resize', handleResize);
  }
}